/* 넘치지 않는 캐러셀의 진행바를 숨긴다.
   스크롤할 것이 없는데 스크롤바가 보이면 고장으로 읽힌다.
   클래스 이름에 기대지 않고 실제 overflow 요소를 찾는다 —
   못 찾으면 그대로 둔다(숨겨서 잃는 쪽이 더 나쁘다). */
(() => {
  const bars = document.querySelectorAll('[class$="__progress"], [class*="__progress "]');
  if (!bars.length) return;

  const scrollableIn = (section) => {
    for (const el of section.querySelectorAll('*')) {
      const ox = getComputedStyle(el).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > 0) return el;
    }
    return null;
  };

  const targets = [];
  bars.forEach((bar) => {
    const section = bar.closest('section, [id^="shopify-section"]');
    if (section) targets.push({ bar, section });
  });
  if (!targets.length) return;

  const sync = () => {
    for (const { bar, section } of targets) {
      // 지금 화면에 없는 것(비활성 탭 등)은 판정 보류 —
      // 여기서 none 을 박으면 탭을 열어도 돌아오지 않는다.
      const sc = scrollableIn(section);
      if (!sc || !sc.clientWidth) continue;    // 판정 불가 → 건드리지 않음
      // display 로 지우면 자리까지 사라져 아래 간격이 튄다 → 자리는 남기고 감춘다
      bar.style.visibility = sc.scrollWidth > sc.clientWidth + 2 ? '' : 'hidden';
    }
  };

  sync();
  const ro = new ResizeObserver(sync);
  targets.forEach(({ section }) => ro.observe(section));
  addEventListener('resize', sync, { passive: true });
  // 탭을 바꾸면 보이는 캐러셀이 달라진다
  document.addEventListener('click', () => setTimeout(sync, 120), true);
  setTimeout(sync, 400);
  setTimeout(sync, 1500);
})();
